import { useCallback, useEffect, useState } from "react";
import toeflLogo from "../assets/images/toefl-logo.svg";
import toeflImgLogo from "../assets/images/toefl-title.png";
import greLogo from "../assets/images/gre-logo.svg";
import "../assets/styles/Header.css";
import { GRE_PROGRAM_ID, TOEFL_PROGRAM_ID } from "../constants/Constants";

const Header = () => {
  const [programId, setProgramId] = useState("");

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const programId = urlParams.get("program_id") || TOEFL_PROGRAM_ID;

    if (programId) setProgramId(programId);
  }, [programId]);

  const getClassNameByProgram = () => {
    if (programId.toUpperCase() == TOEFL_PROGRAM_ID) {
      return "toefl-bg";
    }
    if (programId.toUpperCase() == GRE_PROGRAM_ID) {
      return "gre-bg";
    }
  };
  const getLogoByProgram = useCallback(() => {
    if (programId.toUpperCase() == TOEFL_PROGRAM_ID) {
      return <img src={toeflLogo} />;
    }
    if (programId.toUpperCase() == GRE_PROGRAM_ID) {
      return <img src={greLogo} />;
    }
  });

  return (
    <header className={`${getClassNameByProgram()} sticky-header`}>
      <div className="logo-header">
        <div
          className={`logo-content ${
            programId == GRE_PROGRAM_ID ? "logo-height" : ""
          }`}
        >
          {getLogoByProgram()}
        </div>
      </div>
    </header>
  );
};

export default Header;
